mobileSize = 1000;

// Social Networks
function placeSocialNetworks() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.socialNetworks').appendTo('.footer');
  } else {
    $('.socialNetworks').appendTo('#uc_masterPageWidgets');
  }
}

// Ticket Button
function placeTicketButton() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.ticket').prependTo('.content');
  } else {
    $('.ticket').insertAfter('.subscribe-btn');
  }
}

// Widget Wrapper
function placeWidgetWrapper() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.widget-wrapper').appendTo('.header-top');
  } else {
    $('.widget-wrapper').appendTo('.header-bottom');
  }
}

$(document).ready(function() {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1001) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1000) {
    $('body').removeClass('saffireMobileSize');
  }

  // General Message
  $('.generalmessage').prependTo('header');

  // Animation
  $('.ticket').hover(function() {
    $(this).addClass('animate__animated animate__tada');
  }, function() {
    $(this).removeClass('animate__tada');
  });

  // Social Networks
  placeSocialNetworks();

  // Ticket Button
  placeTicketButton();

  // Widget Wrapper
  placeWidgetWrapper();

  // Custom Email Signup
  $('.homepage .emailSignup .emailSignupText').text('Subscribe to our newsletter');
  $('.homepage .emailSignup .emailSubmitButton')
    .text('Subscribe')
    .appendTo('.homepage .emailInputField');
});

$(window).load(function() {
	$('body').addClass('pageIsLoaded');
});

$(window).resize(function() {
  // Social Networks
  placeSocialNetworks();

  // Ticket Button
  placeTicketButton();

  // Widget Wrapper
  placeWidgetWrapper();
});